export default {
  common: {
    next: 'Pokračovat',
    back: 'Zpět',
    submit: 'Odeslat',
    cancel: 'Zrušit',
    yes: 'ANO',
    no: 'NE',
    required: '*',
    loading: 'Načítání...',
    verifying: 'Ověřování...',
    submitting: 'Odesílám...',
    startingForm: 'Spouštění formuláře...',
    startRegistration: 'Začít registraci',
    selectCountry: 'Vyberte zemi',
    other: 'Jiná',
    specify: 'Upřesněte',
    note: 'Poznámka',
    instructions: 'Instrukce',
    securityNotice: 'Bezpečnostní upozornění',
    importantInfo: 'Důležité informace'
  },
  
  nav: {
    home: 'Domů'
  },
  
  home: {
    title: 'Registrace a AML Dotazník',
    subtitle: 'Vyplňte AML dotazník pro identifikaci a kontrolu klienta ve smyslu zákona č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu.',
    legalEntity: 'Právnická osoba',
    legalEntityDesc: 'Formulář pro společnosti, korporace a jiné právnické subjekty',
    physicalPerson: 'Fyzická osoba',
    physicalPersonDesc: 'Formulář pro jednotlivce a fyzické osoby',
    importantInfoTitle: 'Důležité informace',
    importantInfo1: 'Všechna data jsou bezpečně šifrována',
    importantInfo2: 'Ujistěte se, že máte připravené všechny potřebné dokumenty (OP, ŘP, případně pas)',
    sessionError: 'Nepodařilo se vytvořit relaci. Obnovte prosím stránku a zkuste to znovu.',
    captchaError: 'Ověření captcha selhalo. Obnovte prosím stránku a zkuste to znovu.',
    verifyFirst: 'Nejdříve dokončete ověření, že nejste robot.'
  },
  
  success: {
    title: 'Formulář byl úspěšně odeslán!',
    subtitle: 'Děkujeme za vyplnění AML dotazníku. Vaše údaje byly bezpečně odeslány a zpracovány.',
    submissionDetails: 'Detaily odeslání',
    formType: 'Typ formuláře',
    submissionId: 'ID odeslání',
    submissionTime: 'Čas odeslání',
    legalEntityLabel: 'Právnická osoba',
    physicalPersonLabel: 'Fyzická osoba',
    nextStepsTitle: 'Co bude následovat?',
    nextStep1: 'Vaše údaje byly odeslány k dalšímu zpracování',
    nextStep2: 'Všechna data jsou bezpečně zašifrována',
    nextStep3: 'Budeme vás kontaktovat na uvedené kontaktní údaje',
    nextStep4: 'Vložená data byla automaticky smazána z vašeho prohlížeče, stránku nyní můžete zavřít',
    newForm: 'Vyplnit nový formulář',
    contactUs: 'Pokud máte dotazy, kontaktujte nás na:'
  },
  
  notFound: {
    title: 'Stránka nenalezena',
    message: 'Požadovaná stránka neexistuje.',
    backHome: 'Zpět na hlavní stránku'
  },
  
  draftRecovery: {
    title: 'Nalezena rozpracovaná verze',
    message: 'Máte rozpracovanou verze formuláře pro',
    legalEntityLabel: 'Právnickou osobu',
    physicalPersonLabel: 'Fyzickou osobu',
    question: 'Co chcete udělat?',
    continueDraft: 'Pokračovat v rozpracované verzi',
    startNew: 'Začít znovu (smaže rozpracovanou verzi)'
  },
  
  validation: {
    fillAllFields: 'Vyplňte všechna povinná pole',
    invalidEmail: 'Zadejte platný email',
    uploadAllDocuments: 'Nahrajte všechny 4 strany dokladů (2 doklady × 2 strany)',
    selectTwoDocuments: 'Musíte vybrat přesně 2 typy dokladů',
    icoLength: 'IČO musí mít 8 číslic'
  },
  
  documents: {
    title: 'Dokumenty totožnosti',
    selectTwoTypes: 'Vyberte 2 typy dokladů totožnosti',
    idCard: 'Občanský průkaz',
    driverLicense: 'Řidičský průkaz',
    passport: 'Cestovní pas',
    frontSide: 'Přední strana',
    backSide: 'Zadní strana',
    uploadInstructions: 'Vyberte 2 ze 3 dostupných typů dokladů totožnosti. Pro každý doklad nahrajte 2 fotografie - přední a zadní stranu.',
    securityNotice: 'Tyto dokumenty obsahují citlivé osobní údaje. Soubory budou bezpečně zašifrovány před odesláním a po úspěšném odeslání formuláře budou automaticky smazány z vašeho zařízení.',
    requirements: {
      imagesOnly: 'Pouze obrázky (JPG, PNG)',
      maxSize: 'Maximální velikost: 10MB',
      readable: 'Doklad musí být dobře čitelný'
    }
  },
  
  fileUpload: {
    allowedFormats: 'Povolené formáty: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG',
    maxSize: 'Maximální velikost souboru: 10MB',
    companyDocReq: 'Právnická osoba doloží doklad o existenci právnické osoby (výpis z OR, apod.)'
  },
  
  physicalPerson: {
    step1: {
      title: 'KROK 1 - Identifikační údaje klienta',
      firstName: 'Křestní Jméno',
      lastName: 'Příjmení',
      birthNumber: 'Rodné číslo (není li, vložte datum narození)',
      birthNumberPlaceholder: '123456/7890 nebo DD.MM.YYYY',
      birthPlace: 'Místo narození (město a stát)',
      birthPlacePlaceholder: 'Praha, Česká republika',
      address: 'Trvalý nebo jiný pobyt / Sídlo',
      addressPlaceholder: 'Zadejte adresu',
      citizenship: 'Státní občanství',
      citizenshipPlaceholder: 'Česká republika',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@vasefirma.cz',
      taxResidence: 'Daňová rezidence',
      taxResidencePlaceholder: 'ČR',
      identityDocumentsTitle: 'Dokumenty totožnosti fyzické osoby (klienta)'
    },
    step2: {
      title: 'KROK 2 - Zastoupení klienta',
      hasRepresentative: 'Je klient zastoupen?',
      representativeNote: '(osoba jednající jménem klienta v daném obchodu)',
      noRepresentativeInfo: 'Klient nebude zastoupen. Pokračujte prosím na krok 4.',
      hasRepresentativeInfo: 'Klient bude zastoupen. V dalším kroku budete vyplňovat údaje o zástupci.'
    },
    step3: {
      title: 'KROK 3 - Údaje o zástupci',
      skipNotice: 'Tento krok se přeskakuje, protože klient nebude zastoupen.',
      continueToStep4: 'Pokračovat na krok 4',
      representationType: 'Typ zastoupení',
      nameLabel: 'Jméno a příjmení / firma / název',
      namePlaceholder: 'Zadejte jméno a příjmení nebo název',
      gender: 'Pohlaví',
      taxResidenceNote: 'Není-li uveden žádný stát, klient prohlašuje, že je daňovým rezidentem pouze toho státu, na jehož území se nachází trvalé bydliště klienta. Obecně pro stanovení daňové rezidence klienta platí pravidlo, že je daňovým rezidentem státu, na jehož území se alespoň 183 dní v roce zdržuje, pokud tento stát nestanoví jiná pravidla pro určení daňové rezidence.',
      guardianNote: '(Opatrovník je povinen předložit příslušné rozhodnutí soudu.)',
      identityDocumentsTitle: 'Dokumenty totožnosti zástupce fyzické osoby'
    },
    step4: {
      title: 'KROK 4 - Kontrola klienta - Zdroje příjmů',
      incomeSource: 'Zdroje příjmů',
      otherIncomeSource: 'Upřesněte jiný zdroj příjmů',
      otherIncomePlaceholder: 'Zadejte jiný zdroj příjmů',
      incomeNature: 'Povaha převažujícího zdroje příjmů (Obor)',
      incomeNaturePlaceholder: 'Např. IT služby, obchod, výroba...',
      annualIncome: 'Čisté roční příjmy /roční obrat',
      annualIncomePlaceholder: 'Zadejte roční příjmy/obrat',
      incomeSourceNature: 'Povaha převažujícího zdroje příjmů',
      incomeSourceNaturePlaceholder: 'Detailní popis povahy převažujícího zdroje příjmů',
      netAnnualIncome: 'Čisté roční příjmy',
      netAnnualIncomePlaceholder: 'Zadejte čisté roční příjmy'
    },
    step5: {
      title: 'KROK 5 - Předpokládané transakce',
      monthlyVolume: 'Předpokládaný měsíční objem transakcí',
      monthlyVolumePlaceholder: 'Zadejte předpokládaný měsíční objem transakcí',
      paymentPurpose: 'Předpokládaný účel platby',
      paymentPurposePlaceholder: 'Zadejte předpokládaný účel platby',
      transactionType: 'Nejčastější typ transakcí při výplatě peněz',
      transactionTypePlaceholder: 'Zadejte nejčastější typ transakcí při výplatě peněz'
    },
    step6: {
      title: 'KROK 6 - Politicky exponovaná osoba a mezinárodní sankce',
      isPEP: 'Jste politicky exponovaná osoba?',
      pepDetails: 'Upřesněte',
      pepDetailsPlaceholder: 'Upřesněte funkci nebo postavení',
      pepNote: 'a) fyzická osoba, která je nebo byla ve významné veřejné funkci s celostátním nebo regionálním významem, jako je zejména hlava státu, předseda vlády, vedoucí ústředního orgánu státní správy a jeho zástupce (náměstek, státní tajemník), člen parlamentu, člen řídícího orgánu politické strany, vedoucí představitel územní samosprávy (starosta, hejtman), soudce nejvyššího soudu, ústavního soudu nebo jiného nejvyššího justičního orgánu, proti jehož rozhodnutí obecně až na výjimky nelze použít opravné prostředky, člen bankovní rady centrální banky, vysoký důstojník ozbrojených sil nebo sboru, člen nebo zástupce člena, je-li jím právnická osoba, statutárního orgánu obchodní korporace ovládané státem, velvyslanec nebo vedoucí diplomatické mise, anebo fyzická osoba, která obdobnou funkci vykonává nebo vykonávala v jiném státě, v orgánu Evropské unie anebo v mezinárodní organizaci, b) fyzická osoba, která je 1. osobou blízkou k osobě uvedené v písmenu a), 2. společníkem nebo skutečným majitelem stejné právnické osoby, popřípadě svěřenského fondu nebo jiného právního uspořádání bez právní osobnosti, jako osoba uvedená v písmenu a), nebo je o ní povinné osobě známo, že je v jakémkoli jiném blízkém podnikatelském vztahu s osobou uvedenou v písmenu a), nebo 3. skutečným majitelem právnické osoby, popřípadě svěřenského fondu nebo jiného právního uspořádání bez právní osobnosti, o kterých je povinné osobě známo, že byly vytvořeny ve prospěch osoby uvedené v písmenu a).',
      isSanctioned: 'Jste předmětem sankcí České republiky nebo mezinárodních sankcí',
      sanctionDetails: 'Upřesněte',
      sanctionDetailsPlaceholder: 'Upřesněte typ a rozsah sankcí',
      sanctionNote: 'Mezinárodními sankcemi se podle zákona č. 69/2006 Sb., o mezinárodních sankcích rozumí příkaz, zákaz nebo omezení stanovené za účelem udržení nebo obnovení mezinárodního míru a bezpečnosti, boje proti terorismu, dodržování mezinárodního práva, ochrany lidských práv a svobod a podpory demokracie a právního státu.'
    },
    step7: {
      title: 'KROK 7 - Odeslání a podpis',
      legalNotice: 'Klient bere na vědomí a podpisem tohoto dokumentu souhlasí s tím, že Společnost zpracovává osobní údaje klienta v rozsahu potřebném pro uplatňování práv a plnění povinností vyplývajících z platných právních předpisů a smluvních ujednání, mj. i za účelem identifikace a kontroly klienta ve smyslu zákona č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu.',
      clientStatement: 'Prohlášení klienta:',
      clientStatementText: 'Potvrzuji, že všechny výše uvedené údaje jsou úplné a pravdivé, že jsem nezamlčel žádné důležité údaje, které mi jsou nebo mohou být známy, a zavazuji se bez zbytečného odkladu nahlásit Společnosti jejich změnu.',
      signature: 'Podpis klienta (zadejte celé jméno)',
      signaturePlaceholder: 'Zadejte své celé jméno jako elektronický podpis',
      signatureNote: 'Zadáním vašeho celého jména potvrzujete pravdivost všech uvedených údajů',
      finalConfirmation: 'Potvrzujem, že jsem si přečetl(a) a souhlasím se všemi uvedenými podmínkami a že všechny poskytnuté informace jsou pravdivé a úplné.',
      dataProcessingNotice: 'Informace o zpracování dat:',
      dataProcessingText: 'Vaše data budou bezpečně zašifrována před odesláním na náš server. Po úspěšném odeslání budou všechna místní data automaticky smazána z vašeho zařízení.',
      submitButton: 'ODESLAT REGISTRACI FYZICKÉ OSOBY'
    }
  },
  
  legalEntity: {
    step1: {
      title: 'KROK 1 - Identifikační údaje klienta',
      companyDocumentsLabel: 'Firma / Jiná forma název (včetně odlišujícího dodatku nebo dalšího označení)',
      companyName: 'Název společnosti',
      companyNamePlaceholder: 'Zadejte název společnosti',
      address: 'Sídlo/místo podnikání',
      addressPlaceholder: 'Zadejte sídlo společnosti',
      ico: 'Identifikační číslo (IČO)',
      icoPlaceholder: 'Zadejte IČO',
      dic: 'Daňové identifikační číslo (DIČ)',
      dicPlaceholder: 'Zadejte DIČ (volitelné)',
      taxResidence: 'Daňová rezidence',
      registryInfo: 'Údaje o zápisu do rejstříku',
      registryInfoPlaceholder: 'Zadejte údaje o zápisu do rejstříku',
      actualOwner: 'Skutečný majitel',
      actualOwnerPlaceholder: 'Dle § 4 odst. 4 zákona č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu, ve znění pozdějších předpisů',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@vasefirma.cz'
    },
    step2: {
      title: 'KROK 2 - Údaje o fyzické osobě oprávněné jednat za klienta – právnickou osobou',
      note: 'Pokud fyzická osoba jedná za právnickou osobu na základě plné moci je povinna tuto písemnou plnou moc předložit, jedná-li jako zaměstnanec, pak je musí fyzická osoba předložit pracovní smlouvu a pověření opravňující jí jednat za právnickou osobu má-li právnická osoba jiné zastoupení, je nutno předložit příslušné rozhodnutí soudu nebo jinou listinu, na základě které tato fyzická osoba jedná.',
      representation: 'Zastoupení Statutárním orgánem',
      representationPlaceholder: 'Vyberte typ zastoupení',
      firstName: 'Křestní Jméno',
      firstNamePlaceholder: 'Zadejte křestní jméno',
      lastName: 'Příjmení',
      lastNamePlaceholder: 'Zadejte příjmení',
      birthNumber: 'Rodné číslo (není li, vložte datum narození)',
      birthNumberPlaceholder: '123456/7890 nebo DD.MM.YYYY',
      birthPlace: 'Místo narození (město a stát)',
      birthPlacePlaceholder: 'Praha, Česká republika',
      address: 'Trvalý nebo jiný pobyt / Sídlo',
      addressPlaceholder: 'Zadejte adresu',
      gender: 'Pohlaví',
      citizenship: 'Státní občanství',
      citizenshipPlaceholder: 'Česká republika',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'Email',
      emailPlaceholder: 'email@vasefirma.cz',
      taxResidence: 'Daňová rezidence',
      taxResidencePlaceholder: 'Česká republika',
      isPEP: 'Jste politicky exponovaná osoba?',
      pepDetails: 'Upřesněte',
      pepDetailsPlaceholder: 'Upřesněte funkci nebo postavení',
      pepNote: 'Politicky exponovaná osoba je fyzická osoba, která je nebo byla ve významné veřejné funkci s celostátním nebo regionálním významem...',
      isSanctioned: 'Jste předmětem sankcí České republiky nebo mezinárodních sankcí',
      sanctionDetails: 'Upřesněte',
      sanctionDetailsPlaceholder: 'Upřesněte typ a rozsah sankcí'
    },
    step3: {
      title: 'KROK 3 - Ověření dokladů totožnosti fyzické osoby oprávněné jednat za klienta',
      instructions: 'Vyberte 2 ze 3 dostupných typů dokladů totožnosti. Pro každý doklad nahrajte 2 fotografie - přední a zadní stranu.',
      selectDocuments: 'Vyberte 2 typy dokladů totožnosti',
      securityNotice: 'Tyto dokumenty obsahují citlivé osobní údaje. Soubory budou bezpečně zašifrovány před odesláním a po úspěšném odeslání formuláře budou automaticky smazány z vašeho zařízení.'
    },
    step4: {
      title: 'KROK 4 - Kontrola Klienta',
      incomeSource: 'Zdroje příjmů',
      otherIncomeSource: 'Upřesněte jiný zdroj příjmů',
      otherIncomePlaceholder: 'Zadejte jiný zdroj příjmů',
      incomeNature: 'Povaha převažujícího zdroje příjmů (Obor)',
      incomeNaturePlaceholder: 'Např. IT služby, obchod, výroba...',
      annualIncome: 'Čisté roční příjmy /roční obrat',
      annualIncomePlaceholder: 'Zadejte roční příjmy/obrat'
    },
    step5: {
      title: 'KROK 5 - Předpokládané transakce',
      monthlyVolume: 'Předpokládaný měsíční objem transakcí',
      monthlyVolumePlaceholder: 'Zadejte předpokládaný měsíční objem transakcí',
      paymentPurpose: 'Předpokládaný účel platby',
      paymentPurposePlaceholder: 'Zadejte předpokládaný účel platby',
      transactionType: 'Nejčastější typ transakcí při výplatě peněz',
      transactionTypePlaceholder: 'Zadejte nejčastější typ transakcí při výplatě peněz'
    },
    step6: {
      title: 'KROK 6 - Odeslání a podpis',
      noteTitle: 'Poznámka:',
      legalNotice: 'Klient bere na vědomí a podpisem tohoto dokumentu souhlasí s tím, že Společnost zpracovává osobní údaje klienta v rozsahu potřebném pro uplatňování práv a plnění povinností vyplývajících z platných právních předpisů a smluvních ujednání, mj. i za účelem identifikace a kontroly klienta ve smyslu zákona č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu.',
      clientStatement: 'Prohlášení klienta:',
      clientStatementText: 'Potvrzuji, že všechny výše uvedené údaje jsou úplné a pravdivé, že jsem nezamlčel žádné důležité údaje, které mi jsou nebo mohou být známy, a zavazuji se bez zbytečného odkladu nahlásit Společnosti jejich změnu.',
      signature: 'Podpis klienta (zadejte celé jméno)',
      signaturePlaceholder: 'Zadejte své celé jméno jako elektronický podpis',
      signatureNote: 'Zadáním vašeho celého jména potvrzujete pravdivost všech uvedených údajů',
      finalConfirmation: 'Potvrzujem, že jsem si přečetl(a) a souhlasím se všemi uvedenými podmínkami a že všechny poskytnuté informace jsou pravdivé a úplné.',
      dataProcessingNotice: 'Informace o zpracování dat:',
      dataProcessingText: 'Vaše data budou bezpečně zašifrována před odesláním na náš server. Po úspěšném odeslání budou všechna místní data automaticky smazána z vašeho zařízení.',
      submitButton: 'ODESLAT REGISTRACI PRÁVNICKÉ OSOBY'
    }
  },
  
  options: {
    representationType: {
      statutory: 'Statutárním orgánem',
      powerOfAttorney: 'Na základě plné moci',
      legalGuardian: 'Zákonným zástupcem',
      guardian: 'Opatrovníkem'
    },
    legalRepresentationType: {
      powerOfAttorney: 'Na základě plné moci',
      employee: 'Zaměstnancem',
      other: 'Jiné zastoupení'
    },
    gender: {
      male: 'Muž',
      female: 'Žena',
      other: 'Jiné'
    },
    incomeSource: {
      employee: 'Zaměstnanec',
      entrepreneur: 'Podnikatel',
      other: 'Jiná (Uveďte)'
    }
  },
  
  countries: {
    czechRepublic: 'Česká republika',
    slovakRepublic: 'Slovenská republika',
    poland: 'Polsko',
    otherCountries: 'Ostatní země'
  }
}
